import { observer } from "mobx-react"
import React, { useState, useEffect } from "react"
import ModalStore from "../../Configs/Store/modals"
import CircleIcon from "../Common/CircleIcon"
import CloseButton from "../Common/CloseButton"
import "../../styles/Header/talkToExpertModal.less"
import GenericModal from "../Common/GenericModal"
import TalkToExpertModalJson from "../../Configs/JSON/talkToExpertModal.json"
import TextMultiStyle from "../Common/TextMultiStyle"
import AppStore from "../../Configs/Store/index"
import CommonStore from "../../Configs/Store/common"
import calculator from "../../Configs/Store/calculator"
import Howjson from "../../Configs/JSON/HowItWorks.json"
import DataJson from "../../Configs/JSON/KnowMoreModal.json"

import Icon1 from "../../assets/KnowMoreModal/Icon1.svg"
import Icon2 from "../../assets/KnowMoreModal/Icon2.svg"
import Icon3 from "../../assets/KnowMoreModal/Icon3.svg"
import Icon4 from "../../assets/KnowMoreModal/Icon4.svg"
import Icon5 from "../../assets/KnowMoreModal/Icon5.svg"

const KnowMoreModal = observer(() => {
  // const handleclose = () => ModalStore.setKnowMore(false)
  const closeAllBenMobModal = () => {
    CommonStore.setmythBusterModal(false)
  }

  const [isActive, setActive] = useState(false)

  const toggleClass = () => {
    setActive(!isActive)
  }
  const HowItWorksJson = Howjson.Extracontent

  // return (
  //   <>
  //     <div className="common-modal-wrap">
  //       <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  //         <div className="modal-dialog modal-dialog-centered" role="document">
  //           <div className={calculator.screenNo === "Scr6" ? "modal-content" : "HowWoksStory"}>

  //               <div className="ContainerTop">
  //               <button  className="CloseButton" data-dismiss="modal" aria-label="Close">
  //                 {/* <span aria-hidden="true">&times;</span> */}
  //               </button>
  //                 <div className="ContentSet">
  //                   <img className="Image1" src={Icon4} alt="icon"/>
  //                   <div className="TextSet1">
  //                     <p className="Text1">{DataJson.text1}</p>
  //                     <p className="Text2">{DataJson.text2}</p>
  //                     <p className="Text3"  dangerouslySetInnerHTML={{ __html: DataJson.text3 }}></p>
  //                   </div>
  //                 </div>

  //               </div>

  //               <div className="ContainerBottom">
  //                 <div className="BottomLeft">
  //                   <img className="Image2" src={Icon3} alt="icon"/>
  //                   <p className="Text4">{DataJson.text4}</p>
  //                   <div className="Set2">
  //                     <img className="Image3" src={Icon2} alt="icon"/>
  //                     <p className="Text5"  dangerouslySetInnerHTML={{ __html: DataJson.text5}}></p>
  //                   </div>
  //                   <p className="Text6">{DataJson.text6}</p>
  //                   <p className="Text7">{DataJson.text7}</p>
  //                 </div>
  //                 <div className="BottomRight">
  //                   <img className="Image4" src={Icon1} alt="icon"/>
  //                   <p className="Text8">{DataJson.text8}</p>
  //                   <p className="Text9">{DataJson.text9}</p>
  //                   <p className="Text10">{DataJson.text10}</p>
  //                   <img className="Image4" src={Icon1} alt="icon"/>
  //                   <p className="Text11">{DataJson.text11}</p>
  //                 </div>
  //                 <img className="Image5" src={Icon5} alt="icon"/>
  //                 <div className="TextSet2">
  //                   <p className="Text12">{DataJson.text12}</p>
  //                   <p className="Text13">{DataJson.text13}</p>
  //                 </div>
  //                 <p className="Text14">{DataJson.text14}</p>
  //                 <div className="DottetLine"></div>
  //                 <div className="TextSet3">
  //                   <p className="Number">{DataJson.number1}</p>
  //                   <p className="Number">{DataJson.number2}</p>
  //                   <p className="Number">{DataJson.number3}</p>
  //                 </div>

  //               </div>

  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </>
  // )

  const handleclose = () => CommonStore.setStoryModal(false)

  return (
    <GenericModal
      visibleState={CommonStore.StoryModal}
      updateVisibility={handleclose}
      rootClassAntCustom={"HowWoksStory"}
      showButton={false}
      zIndex={1060}
      component={
        <div className="HowWoksStory">
          <div className="ContainerTop">
            <button className="CloseButton" data-dismiss="modal" aria-label="Close" onClick={handleclose}>
              {/* <span aria-hidden="true">&times;</span> */}
            </button>
            <div className="ContentSet">
              <img className="Image1" src={Icon4} alt="icon" />
              <div className="TextSet1">
                <p className="Text1">{DataJson.text1}</p>
                <p className="Text2">{DataJson.text2}</p>
                <p className="Text3" dangerouslySetInnerHTML={{ __html: DataJson.text3 }}></p>
              </div>
            </div>
          </div>

          <div className="ContainerBottom">
            <div className="BottomLeft">
              <img className="Image2" src={Icon3} alt="icon" />
              <p className="Text4">{DataJson.text4}</p>
              <div className="Set2">
                <img className="Image3" src={Icon2} alt="icon" />
                <p className="Text5" dangerouslySetInnerHTML={{ __html: DataJson.text5 }}></p>
              </div>
              <p className="Text6">{DataJson.text6}</p>
              <p className="Text7">{DataJson.text7}</p>
            </div>
            <div className="BottomRight">
              <img className="Image4" src={Icon1} alt="icon" />
              <p className="Text8">{DataJson.text8}</p>
              <p className="Text9">{DataJson.text9}</p>
              <p className="Text10">{DataJson.text10}</p>
              <img className="Image4" src={Icon1} alt="icon" />
              <p className="Text11">{DataJson.text11}</p>
            </div>
            <img className="Image5" src={Icon5} alt="icon" />
            <div className="TextSet2">
              <p className="Text12">{DataJson.text12}</p>
              <p className="Text13">{DataJson.text13}</p>
            </div>
            <p className="Text14">{DataJson.text14}</p>
            <div className="DottetLine"></div>
            <div className="TextSet3">
              <p className="Number">{DataJson.number1}</p>
              <p className="Number">{DataJson.number2}</p>
              <p className="Number">{DataJson.number3}</p>
            </div>
          </div>

          <div className="ContainerFooter">
          <p className="para" dangerouslySetInnerHTML={{ __html: DataJson.footer }}></p>
          </div>

        </div>
      }
    />
  )
})

export default KnowMoreModal
